import corporateConcierge from "./modules/corporate-fbac";
import careersConcierge from "./modules/careers-fbac";

corporateConcierge.init();
careersConcierge.init();
